/**
 * The Worker base URL. Set at build time via VITE_WORKER_URL (see .env.production
 * / the deploy step). Falls back to same-origin `/api` for local dev against
 * `wrangler dev` behind a proxy, which is never used in production.
 */
export const WORKER_URL: string = import.meta.env.VITE_WORKER_URL ?? '';

export function workerEndpoint(path: string): string {
  if (!WORKER_URL) {
    throw new Error('VITE_WORKER_URL is not configured.');
  }
  return `${WORKER_URL}${path}`;
}
